document
	.querySelectorAll('[data-product-comparison]')
	.forEach(productComparisonEl => {
		let lastClick: HTMLElement | null = null;

		const productEls = productComparisonEl.querySelectorAll<HTMLElement>(
			'[data-product]',
		);

		const featureEls = productComparisonEl.querySelectorAll<HTMLElement>(
			'[data-feature]',
		);

		const findAndSetImageClassName = (
			parentEl: HTMLElement,
			matching: boolean,
		) => {
			const imageEl = parentEl.querySelector('.product-image');
			imageEl?.classList.toggle('product-image--active', matching);
		};

		const setActiveElement = (
			els: NodeListOf<HTMLElement>,
			el: HTMLElement | null,
		) => {
			els.forEach(thisEl => {
				const activeClass = thisEl.getAttribute('data-active-class') || '';
				const matching = el === null ? false : thisEl === el;

				thisEl.classList.toggle(activeClass, matching);
				findAndSetImageClassName(thisEl, matching);
			});
		};

		const setMatchingProducts = (
			els: NodeListOf<HTMLElement>,
			feature: string,
		) => {
			els.forEach(thisEl => {
				const features = (thisEl.getAttribute('data-product') || '').split(',');
				const matching = features.includes(feature);

				const activeClass = thisEl.getAttribute('data-active-class') || '';

				thisEl.classList.toggle(activeClass, matching);
				findAndSetImageClassName(thisEl, matching);
			});
		};

		const setMatchingFeatures = (
			els: NodeListOf<HTMLElement>,
			features: string[],
		) => {
			els.forEach(thisEl => {
				const feature = thisEl.getAttribute('data-feature');
				const matching = feature !== null && features.includes(feature);
				const activeClass = thisEl.getAttribute('data-active-class') || '';

				thisEl.classList.toggle(activeClass, matching);
				findAndSetImageClassName(thisEl, matching);
			});
		};

		productEls.forEach(productEl => {
			productEl.addEventListener('click', () => {
				if (productEl === lastClick) {
					setActiveElement(productEls, null);
					setActiveElement(featureEls, null);
					lastClick = null;
					return;
				}

				setActiveElement(productEls, productEl);

				const features = productEl.getAttribute('data-product');
				if (features) {
					setMatchingFeatures(featureEls, features.split(','));
				}

				lastClick = productEl;
			});
		});

		featureEls.forEach(featureEl => {
			featureEl.addEventListener('click', () => {
				if (featureEl === lastClick) {
					setActiveElement(productEls, null);
					setActiveElement(featureEls, null);
					lastClick = null;
					return;
				}

				setActiveElement(featureEls, featureEl);

				const feature = featureEl.getAttribute('data-feature');
				if (feature) {
					setMatchingProducts(productEls, feature);
				}

				lastClick = featureEl;
			});
		});
	});
